import { FoodsIcon } from "@foodpilot/foods";
import { Box, Button, List, ListItem, styled } from "@mui/material";

type IndexItem = {
    key: string;
    title: string;
};
type IndexListProps = {
    items: IndexItem[];
    selectedIndex: string;
    onClick: (selectedIndex: string) => void;
};
export const IndexList = (props: IndexListProps) => {
    const { items, selectedIndex, onClick } = props;
    return (
        <List>
            {items.map((indexItem) => {
                const isSelected = selectedIndex === indexItem.key;
                return (
                    <ComparisonListItem key={indexItem.key} onClick={() => onClick(indexItem.key)}>
                        <ComparisonScoreButton variant="text" isSelected={isSelected}>
                            {indexItem.title}
                            <ComparisonListItemIndicator selected={isSelected}>
                                <FoodsIcon icon="arrowRight" size={2} />
                            </ComparisonListItemIndicator>
                        </ComparisonScoreButton>
                    </ComparisonListItem>
                );
            })}
        </List>
    );
};

const ComparisonListItem = styled(ListItem)(({ theme }) => ({
    padding: theme.spacing(0, 2, 0, 0),
    transform: `translateY(-${theme.spacing(2)})`,
    justifyContent: "center",
    display: "flex",
}));

const ComparisonScoreButton = styled(Button)<{ isSelected: boolean }>(({ theme, isSelected }) => ({
    display: "flex",
    height: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "left",
    width: "100%",
    color: isSelected ? theme.palette.primary[700] : theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: "600",
    transition: "color 0.2s ease",
    "&:hover": {
        color: theme.palette.common.black,
        textDecoration: "none",
    },
}));

const ComparisonListItemIndicator = styled(Box)<{ selected: boolean }>(({ selected }) => ({
    opacity: selected ? 1 : 0,
    transition: "opacity 0.2s ease",
    display: "flex",
    alignItems: "center",
}));
